import { useEffect } from 'react'

export default function NotFound() {
  useEffect(() => {
    setTimeout(() => (document.location = `/`), 4000)
  }, [])
  return <div className="grid h-screen place-items-center">Hey There. I'm sorry to say this page doesn't exist.</div>
}
